<template lang="pug">
  div
    v-row.pa-4(no-gutters align="center")
      v-col.pr-2
        v-text-field(v-model="searchText" :placeholder="$t('search_order')" hide-details dense outlined height="40" background-color="basic200")
          template(v-slot:append)
            eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600" )
      v-col.py-2.shrink
        v-btn.elevation-0.pa-0(color="transparent" small icon @click="openOrderFilter = true")
          eva-icon(name="options-2-outline" :fill="$vuetify.theme.themes[$theme].primary400" height="23" style="margin-top: 2px")
    order-shipping-filters-chip(v-if="checkFilter" :company="company")
    v-container.pa-0(style="max-width: 600px")
      div
        v-divider.basic300
        div.py-3.px-4.d-flex.align-center(v-if="!isFetching")
          bulk-order-actions(:leads="leads")
          y-pagination(v-model="page" :pageSize="fetchCount" :count="totalCount")
      v-layout.my-6.px-2.pt-2(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .content-layout(v-else)
        v-layout.my-6.px-2.pt-2(v-if="leads.length == 0")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(:src="require('@/assets/images/order_mgmt_empty.png')" style="width:80px; height:80px" contain)
              div.p2.basic600--text.text-center {{ $t('no_orders_found') }}
              div.p2.basic600--text.text-center {{ $t('no_orders_adjust_filter') }}
        div(v-else)
          v-divider.basic300
          div(v-for="(lead, index) in leads" :key="lead.id")
            post-order-item(:parentLead.sync="lead" :menu="menu" @deleted="handleDeletedItem($event)")
            v-divider.basic300
        div.py-3.px-4
          y-pagination-custom(v-if="leads.length > 0" v-model="page" :parentPageSize.sync="fetchCount" :count="totalCount" :text="'Show orders'")
    .modal
      order-filter(v-if="openOrderFilter" :open.sync="openOrderFilter" :company="company" :orderType="'completed'")
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import queryString from 'query-string'
import OrderShippingFiltersChip from '@/components/ordermgmt/OrderShippingFiltersChip.vue'
import PostOrderItem from '@/components/ordermgmt/PostOrderItem.vue'
import OrderFilter from '@/components/dialogs/order/OrderFilter.vue'
import BulkOrderActions from '@/components/ordermgmt/BulkOrderActions'

export default {
  name: 'OrderCompleted',
  components: { OrderShippingFiltersChip, PostOrderItem, OrderFilter, BulkOrderActions },
  props: ['company', 'menu'],
  data: (vm) => ({
    isFetching: false,
    searchCountDown: null,
    page: 1,
    fetchCount: 20,
    totalCount: vm.$store.state.ui.pendingOrderCount,
    leads: [],
    checkAll: false,
    openOrderFilter: false,
    searchText: '',
  }),
  computed: {
    ...mapState('user', ['user', 'member']),
    ...mapGetters({
      view: 'orders/getOrderView',
      filters: 'orders/getFilters'
    }),
    checkFilter () {
      if (!this.filters.sort && !this.filters.date && !this.filters.range && !this.filters.processing && !this.filters.ready && !this.filters.shipping && !this.filters.payment && !this.filters.source) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
    page (val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        this.fetchLeads(val)
      }
    },
    fetchCount () {
      this.page = 1
      this.fetchLeads(1)
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.fetchLeads(1)
      }, 500)
    },
    filters: {
      deep: true,
      handler () {
        this.fetchLeads(1)
      }
    },
    '$store.state.orders.leadsVersion' () {
      this.fetchLeads(1)
    }
  },
  mounted () {
    this.fullscreen = window.innerWidth < 600
    // this.fetchZones()
    if (!this.$route.query.page) {
      this.fetchLeads(1)
    } else {
      this.fetchLeads(this.$route.query.page)
    }
    // this.$store.commit('tours/setOrderManagementListViewTour')
    // this.$nextTick(() => {
    //   setTimeout(() => {
    //     this.$tours['YezzaTour'].start()
    //   }, 2000)
    // })
  },
  methods: {
    fetchLeads(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let params = new URLSearchParams()
      params.append('page', page)
      params.append('page_size', this.fetchCount)
      params.append('form__company', this.company.id)
      params.append('form_type_exclude', 'book_income')
      params.append('status', 'received')
      if (this.searchText && this.searchText.length >= 2 && this.searchText.includes('#')) {
        params.append('rid', this.searchText.replace('#', ''))
      } else if (this.searchText) {
        params.append('search', this.searchText)
      }
      if (this.member.role !== 'Admin') {
        params.append('member', this.member.id)
      }
      if (this.filters.sort === 'oldest') {
        params.append('ordering', 'processed_at')
      } else {
        params.append('ordering', '-processed_at')
      }
      if (this.filters.date && this.filters.range) {
        if (this.filters.date === 'created') {
          if (this.filters.range.dates) {
            if (this.filters.range.dates.length === 1) {
              params.append('processed_at_after', this.filters.range.dates[0])
              params.append('processed_at_before', this.filters.range.dates[0])
            } else {
              if (this.filters.range.dates[0] < this.filters.range.dates[1]) {
                params.append('processed_at_after', this.filters.range.dates[0])
                params.append('processed_at_before', this.filters.range.dates[1])
              } else {
                params.append('processed_at_after', this.filters.range.dates[1])
                params.append('processed_at_before', this.filters.range.dates[0])
              }
            }
          } else {
            if (this.filters.range.value) {
              params.append('processed_at_range', this.filters.range.value)
            }
          }
        } else if (this.filters.date === 'scheduled') {
          if (this.filters.range.dates) {
            if (this.filters.range.dates.length === 1) {
              params.append('asking_delivery_date_after', this.filters.range.dates[0])
              params.append('asking_delivery_date_before', this.filters.range.dates[0])
            } else {
              if (this.filters.range.dates[0] < this.filters.range.dates[1]) {
                params.append('asking_delivery_date_after', this.filters.range.dates[0])
                params.append('asking_delivery_date_before', this.filters.range.dates[1])
              } else {
                params.append('asking_delivery_date_after', this.filters.range.dates[1])
                params.append('asking_delivery_date_before', this.filters.range.dates[0])
              }
            }
          } else {
            if (this.filters.range.value) {
              params.append('asking_delivery_date_range', this.filters.range.value)
            }
          }
        } else if (this.filters.date === 'received') {
          if (this.filters.range.dates) {
            if (this.filters.range.dates.length === 1) {
              params.append('received_at_after', this.filters.range.dates[0])
              params.append('received_at_before', this.filters.range.dates[0])
            } else {
              if (this.filters.range.dates[0] < this.filters.range.dates[1]) {
                params.append('received_at_after', this.filters.range.dates[0])
                params.append('received_at_before', this.filters.range.dates[1])
              } else {
                params.append('received_at_after', this.filters.range.dates[1])
                params.append('received_at_before', this.filters.range.dates[0])
              }
            }
          } else {
            if (this.filters.range.value) {
              params.append('received_at_range', this.filters.range.value)
            }
          }
        }
      }
      if (this.filters.shipping && Object.keys(this.filters.shipping).length > 0) {
        params.append('fulfilment_method', JSON.stringify(this.filters.shipping))
      }
      if (this.filters.payment && this.filters.payment.length > 0) {
        this.filters.payment.forEach(o => {
          params.append('payment_method', o.value)
        })
      }
      if (this.filters.source && this.filters.source.length > 0) {
        this.filters.source.forEach(o => {
          params.append('form', o.id)
        })
      }
      this.$axios.get('/leads/', { params: params })
        .then((response) => {
          this.isFetching = false
          this.leads = response.data.results
          this.totalCount = response.data.count
        })
        .catch(() => {})
    },
    handleDeletedItem (item) {
      this.totalCount = this.totalCount - 1
      this.leads = this.leads.filter((x) => x.id !== item.id)
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>